import './style.css';
import { h, FunctionalComponent as FC } from 'preact'
import { Loader } from 'ui';


export const MainLoader: FC = () => {
  return (
    <div className="MainLoader__wrap">
      <div className="MainLoader__loader">
        <Loader />
        <div className="MainLoader__loader__text">Loading...</div>
      </div>
    </div>
  )
}
